var React = require('react');

function CarrotPlantedIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33473 -2.62321e-07L6.66806 -2.91939e-08C7.21742 -5.18041e-09 7.53101 0.627175 7.20139 1.06667L4.53473 4.62222C4.26806 4.97778 3.73473 4.97778 3.46806 4.62222L0.801393 1.06667C0.471775 0.627176 0.785363 -2.86335e-07 1.33473 -2.62321e-07Z","fill":"white"}));
}

CarrotPlantedIcon.defaultProps = {"width":"8","height":"5","viewBox":"0 0 8 5","fill":"none"};

module.exports = CarrotPlantedIcon;

CarrotPlantedIcon.default = CarrotPlantedIcon;
